import { safeApplyFn } from '@/utils/helpers';
import { Modes } from '@/common.js';
import Userback from '@userback/widget';

function applyFn(fn) {
	if ([Modes.Production, Modes.Staging].includes(process.env.NODE_ENV)) {
		return safeApplyFn(fn);
	}
}
/* Private */

let loaded = false;
let ub = null;

/* Public */
function init(user, position = 'e') {
	return applyFn(async () => {
		if (!process.env.VUE_APP_USERBACK_TOKEN) {
			throw new Error("No Userback token provided. Please set the 'VUE_APP_USERBACK_TOKEN' environment variable.");
		}
		if (loaded && ub) {
			window.Userback?.init(process.env.VUE_APP_USERBACK_TOKEN, {
				name: `${user.first_name} ${user.last_name}`,
				email: user.email,
				widget_settings: { position },
			});
		} else {
			ub = await Userback(process.env.VUE_APP_USERBACK_TOKEN, {
				name: `${user.first_name} ${user.last_name}`,
				email: user.email,

				widget_settings: {
					position,
				},
			});
		}
		window.Userback?.identify(user.id, {
			name: `${user.first_name} ${user.last_name}`,
			email: user.email,
			company: user.profile?.account?.name,
			account_id: user.profile?.account?.id,
		});
		loaded = true;
	});
}

function open() {
	return applyFn(() => {
		window.Userback?.open();
	});
}

const UserbackService = {
	init,
	open,
};

export default UserbackService;
